import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import arrow_right from "./../../assets/ic_header_arrow_right.svg";
import arrow_left from "./../../assets/ic_header_arrow_left.svg";
import { useState } from "react";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
export default function FirstTimeEngagedData(props)
{
    const [columnPage,setcolumnPage] =useState(0);

    const columns = [
		{
            id: "resourse_name",
            Header: "Resource Name",
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
            accessor: "resourse_name",
            width: 350,	
            style:{'whiteSpace': 'unset'},
            fixed:"left"				
        },
        // {
        //     id: "resource_type",
        //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
        //     Header: "Resource Type",
        //     accessor: "resource_type",
        //     //width: 150,
        //     getProps: (state, rowInfo, column) => {
        //         return {
        //             style: {
        //                 borderLeft: 'solid 1px #ccc',	
        //                 borderRight:'solid 1px #ccc',				
        //             },
        //         };
        //     },
        // },
        {
            id: "resourse_count",
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            Header: "Resource Count",
            accessor: "resourse_count",
            //width: 150,
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        borderLeft: 'solid 1px #ccc',	
                        borderRight:'solid 1px #ccc',				
                    },
                };
            },
        },

	 ];
	 



    return (
        
		    <ReactTableFixedColumns
                data={props.data || []}
                columns={columns}
                pageSize={props.data.length}
                sortable={false}
                showPagination={false}
                style={{overflowY: "auto",height: "445px"}}	
                className="-striped"
            />
	);
}